module.exports = __webpack_public_path__ + "9d30c7bb01100cae62a75082b69456aa.png";